import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { Player, Controls } from '@lottiefiles/react-lottie-player';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 224 }}
    >
      <Tabs
        variant="scrollable"
        value={value}
        className="primary"
        color="secondary"
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab color="secondary" label="Comprador y Vendedor" {...a11yProps(0)} />
        <Tab color="secondary"label="Tarifas transparentes" {...a11yProps(1)} />
        <Tab color="secondary" label="Beneficios" {...a11yProps(2)} />
        <Tab color="secondary" label="Retirar fondos en cualquier momento" {...a11yProps(3)} />
        <Tab color="secondary" label="Seguro" {...a11yProps(4)} />
        <Tab color="secondary" label="Privado" {...a11yProps(5)} />
        <Tab color="secondary" label="Tarifas bajas y transparentes" {...a11yProps(6)} />
      </Tabs>
      <TabPanel color="secondary" value={value} index={0}>
          <div className="home__Tab">
          <p>

Cuando el comprador inicia una transacción de depósito en garantía, sus TOKENS quedan bloqueados en el contrato inteligente.

Una vez que el comprador confirma que se cumplen las obligaciones del vendedor, puede liberar fondos al vendedor. Un agente de depósito de garantía, elegido por el comprador y el vendedor, supervisa la transacción. Si se produce una disputa, el agente de depósito puede intervenir y reembolsar al comprador o liberar fondos al vendedor.
</p>

<Player
                        className="home__lottie home__maximg"
                        autoplay
                        loop
                        src="./assets/gifts/5721-protocol.json"
                    >
                    </Player>
          </div>
 

      </TabPanel>
      <TabPanel value={value} index={1}>


      <div className="home__Tab">
       
<p>
EMYTO es gratuito para los Compradores y los Agentes de depósito. Sobre la transacción iniciada se cobra una tarifa de desarrollador de 0.25%. Asimismo, y de común acuerdo entre las partes y el Agente de Escrow; sobre el depósito de garantía se fija un porcentaje entre el 0.1% y 5 %.

Elija una entidad justa e imparcial para depositar sus transacciones, como un moderador del foro, agente fiduciario, trader en comercio exterior, escribanos.
El Agente de depósito generalmente cobra una tarifa del 1-2% por las transacciones normales de comercio electrónico.
Por su seguridad, nunca envíe pedidos en custodia de agentes de depósito desconocidos.
</p>

<Player
                        className="home__lottie home__maximg"
                        autoplay
                        loop
                        src="./assets/gifts/5720-trustless.json"
                    >
                    </Player>

                    </div>


      </TabPanel>
      <TabPanel value={value} index={2}>


      <div className="home__Tab">
    <p>  La resolución justa de disputas y tarifas más bajas reducen el costo de vender en línea. </p>


<Player
                        className="home__lottie home__maximg"
                        autoplay
                        loop
                        src="./assets/gifts/5717-decentralized.json"
                    >
                    </Player>
                    </div>
      </TabPanel>
      <TabPanel value={value} index={3}>

      <div className="home__Tab">
       <p>

Una ventaja de la descentralización: ninguna entidad de gobierno controla tus fondos, nadie puede evitar que retires tus fondos.

Podés retirar fondos a medida que se completa cada transacción o acumular varias transacciones y retirarlas juntas.
</p>
<Player
                        className="home__lottie home__maximg"
                        autoplay
                        loop
                        src="./assets/gifts/4180-blockchain-animation.json"
                    >
                    </Player>
                    </div>

      </TabPanel>
      <TabPanel value={value} index={4}>
       
<p>
Smart Contract seguro e inviolable. ¡Blockchain ya es el presente!

Operaciones trazables e inviolables de principio a fin.
</p>

<Player
                        className="home__lottie home__maximg"
                        autoplay
                        loop
                        src="./assets/gifts/65396-secure-blockchain.json"
                    >
                    </Player>

      </TabPanel>
      <TabPanel value={value} index={5}>
          <p>
      Transacciones 100% confidenciales, EMYTO solo te da las herramientas para que las partes interactúen. Somos un agente facilitador de tecnología. No intervenimos ni tenés que registrarte. 100% descentralizada.
      </p>
      <Player
                        className="home__lottie home__maximg"
                        autoplay
                        loop
                        src="./assets/gifts/24097-loader.json"
                    >
                    </Player>
      </TabPanel>
      <TabPanel value={value} index={6}>
          <p>
      EMYTO solo percibe en concepto de costo de desarrollo y mantenimiento de la plataforma el 0,25% de las transacciones.
      </p>
      <Player
                        className="home__lottie home__maximg"
                        autoplay
                        loop
                        src="./assets/gifts/65395-blockchain-animation-2.json"
                    >
                    </Player>
      </TabPanel>
    </Box>
  );
}
